import React, { useContext, useEffect } from "react"
import moment from "moment-timezone"
import DatePicker from "../../../../components/Datepicker"
import PropTypes from "prop-types"
import { SpaceProfileContext } from "../../context"

const DateSelector = ({ pickerDate, updateDatepicker, spCalendar = {} }) => {
  const {
    commonData: { contextMinDate, contextMaxDate },
    actions: { setContextMaxDate },
  } = useContext(SpaceProfileContext)

  useEffect(() => {
    if (spCalendar && spCalendar.available_dates) {
      setContextMaxDate(
        new Date(
          moment()
            .startOf("isoWeek")
            .add(Number(spCalendar.available_dates), "week")
            .day("friday")
            .tz(spCalendar.time_zone)
            .format()
        )
      )
    }


  }, [spCalendar])

  return (
    <DatePicker
      value={pickerDate}
      setValue={updateDatepicker}
      maxDate={contextMaxDate || null}
      minDate={contextMinDate || null}
      inline
    />
  )
}

export default DateSelector

DateSelector.propTypes = {
  pickerDate: PropTypes.object,
  updateDatepicker: PropTypes.func,
  spCalendar: PropTypes.object,
  setEvents: PropTypes.func,
  space: PropTypes.object,
  calendar: PropTypes.object,
  minDate: PropTypes.object,
}
